/* eslint-disable max-len */
import React from 'react';
import _, { uniqBy, truncate } from 'lodash';
import useSearchParams from '~/commons/hooks/useSearchParams';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons/faTimesCircle';
import { env } from '~/commons/config';
import ListResource from '../ListResource.jsx';

const api = '/api/core/tfy/stocks';

const ListTfyStocks = ({ showrooms }) => {
  const [searchParams, setSearchParams] = useSearchParams(null);

  const filter = {};

  const showrms = uniqBy(showrooms, 'orgId');

  if (searchParams.get('status')) {
    filter.status = searchParams.get('status');
  }
  if (searchParams.get('showroom')) {
    filter.orgId = searchParams.get('showroom');
  }

  return (
    <ListResource
      {...{
        searchable: [
          { value: 'all', label: 'All' },
          {
            value: 'erpSync.success',
            label: 'Success Sync',
            options: [
              { value: 1, label: 'True' },
              { value: 0, label: 'False' },
            ],
          },
          { value: 'size', label: 'Size' },
        ],
        api,
        filter,
        sort: { itemCode: 1 },
        actions: {
          create: false,
        },
        cols: [
          {
            key: '_id',
            children: 'Photo',
            getter: (v) => (
              <img
                src={`/api/core/tfy/stocks/${v}/preview.svg`}
                alt={'s'}
                style={{
                  maxWidth: '120px',
                  maxHeight: '120px',
                }}
              />
            ),
          },
          {
            key: 'itemCode',
            sortable: true,
            children: 'Item Code',
          },
          {
            key: 'gdn',
            sortable: true,
            children: 'GDN',
          },
          {
            key: 'status',
            sortable: true,
          },
          {
            key: 'design.coll.name',
            sortable: false,
            children: 'Collection',
          },
          {
            key: 'design.design',
            sortable: false,
            children: 'Design',
          },
          { key: 'size', sortable: true },
          { key: 'prices.currency', sortable: true },
          {
            key: 'prices.retailPrice',
            sortable: true,
            children: 'Price',
            getter: (v) => (Number(v) || 0).toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),
          },
          { key: 'location', sortable: true },
          { key: 'remarks', sortable: true, getter: (v) => truncate(v, { length: 120 }) },
          {
            key: 'erpSync.success',
            sortable: true,
            children: 'Success',
            getter: (v) => (typeof v === 'string' ? v : <FA icon={v ? faCheckCircle : faTimesCircle} />),
          },
        ],
        ctrls: [
          <select
            name="status"
            className="custom-select"
            key={0}
            value={(searchParams.get('status') ? searchParams.get('status') : '')}
            onChange={(e) => {
              setSearchParams({ status: e.target.value });
            }}>
            <option value="">All</option>
            {(env?.status?.tfyStocks).map((a) => (
              <option key={a} value={a}>
                {a}
              </option>
            ))}
          </select>,
          <select
            name="showroom"
            className="custom-select"
            key={1}
            value={(searchParams.get('showroom') ? searchParams.get('showroom') : '')}
            onChange={(e) => {
              setSearchParams({ showroom: e.target.value });
            }}>
            <option value="">All</option>
            {showrms.map((a) => (
              <option key={a._id} value={a.orgId}>
                {`${a.orgId} - ${a.countryCode}`}
              </option>
            ))}
          </select>,
        ],
      }}
    />
  );
};

export default ListTfyStocks;
